import React, { useRef, useEffect, useState } from "react";

import NuLoading from 'components/nubox/NuLoading';
import FileUpload2 from 'components/nubox/FileUpload2';

import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader, 
  ModalBody,
  FormGroup,
  ModalFooter,
} from "reactstrap";

const NuFileUploadModal =(props) =>{
  const [value, setValue] = useState("");

  //const [show, setShow] = useState(false);
  /*const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);*/
  function handleChange(e) {
        setValue(e.target.value);
  }
  const onHandleOK=(data)=>{
    console.log("onHandleOK")
    //e.preventDefault();
    //------------- tenemos que formatear el array antes de pasarlo
    props.handleOK(data)

  }
  const handleCancel=()=>{ 
    console.log("handleCancel")
    props.handleCancel()
    //this.setState({ modalShow: false});
  }
  /************************************************ */
  //-----------------------------------------------
  //--------------------------------------------
  return(
    
    <Modal isOpen={ props.modalShow } >

      {/*<Modal isOpen={ props.modalShow}>*/}
    {/*<ModalHeader>
     <div><h3>{props.titulo}</h3></div>
     { 
     //JSON.stringify(props)
     }
    </ModalHeader>*/}
    
    <ModalBody>
      
      <FormGroup>
        <h3>Subir archivos</h3>
        <div className="alert alert-info alert-dismissible fade show">
          <strong>Info!</strong> Tamaño maximo de archivo permitido es 3 MB.
        </div>
        <FileUpload2
          handleOK={ onHandleOK }
          handleCancel={ handleCancel }
          fileURL={process.env.REACT_APP_AFILES}
          //fileName={this.state.form.fotoca}
          multiple={true}
          autoUpload={true}
        />
      </FormGroup>
      
    </ModalBody>

    {/*<ModalFooter>
      <Button
        color="primary"
        onClick={ (e)=>onHandleOK(e)}
      >
        Aceptar
      </Button> &nbsp;&nbsp;
      <Button
        color="danger"
        onClick={() => { props.handleCancel()}}
      >
        Cancelar
      </Button>
    </ModalFooter>*/}
  </Modal>
  )
}
export default NuFileUploadModal;